import React from "react";
import styled from "styled-components";

import { tablet, tabletLarge } from "styles/breakpoints";
import { useQuery, mobileShort } from "styles/breakpoints";
import { textWhite } from "styles/colors";

import { ContainerMedium, FlexWrapper, ExtraSmallParagraph } from "components";

export const FooterLanding = () => {
  const { isTablet } = useQuery();

  return (
    <FooterContainer>
      <ContainerMedium>
        <FlexWrapper justifyContent={isTablet ? "center" : "space-between"}>
          <ExtraSmallParagraph color={textWhite}>
            © 2021 Play Everywhere. All rights reserved.
          </ExtraSmallParagraph>
          {!isTablet && (
            <ExtraSmallParagraph color={textWhite}>
              Disclaimer: Results may vary from person to person
            </ExtraSmallParagraph>
          )}
        </FlexWrapper>
      </ContainerMedium>
    </FooterContainer>
  );
};

const FooterContainer = styled.div`
  position: absolute;
  bottom: 2.875rem;
  left: 0;
  width: 100%;
  z-index: 1;

  @media ${mobileShort} {
    display: none;
  }

  @media ${tabletLarge} {
    position: relative;
    padding: 0 1rem;
  }

  @media ${tablet} {
    bottom: 0;
    padding: 1rem 0;
  }
`;
